export const COLUMNS_HEADER_USERS_ADMIN = [{
    title: 'Nombre',
    sort: '',
    key: 'name',
    type: 'string',
    isSorteable: true
  }, {
    title: 'Usuario',
    sort: '',
    key: 'username',
    type: 'string',
    isSorteable: true
  }, {
    title: 'Correo electrónico',
    sort: '',
    key: 'email',
    type: 'string',
    isSorteable: true
  }, {
    title: 'Roles',
    sort: '',
    key: 'roles',
    type: 'array',
    isSorteable: false
  }, {
    title: 'Activo',
    sort: '',
    key: 'is_active',
    type: 'boolean',
    isSorteable: false,
    isCentered: true,
    isCheckField: true
  }];

  export const COLUMNS_HEADER_BLENDERS_ADMIN = [{
    title: 'Id',
    sort: '',
    key: 'id',
    type: 'number',
    isSorteable: true
  }, {
    title: 'Descripción',
    sort: '',
    key: 'description',
    type: 'string',
    isSorteable: true
  },
  {
    title: 'Value stream',
    sort: '',
    key: 'value_stream',
    type: 'string',
    isSorteable: true,
    isCentered: true
  }, {
    title: 'Activo',
    sort: '',
    key: 'active',
    type: 'boolean',
    isSorteable: false,
    isCentered: true,
    isCheckField: true
  },{
    title: 'Eliminar',
    sort: '',
    isSorteable: false,
    isColumnDelete: true,
    isCentered: true
  }];

  export const COLUMNS_HEADER_PACKAGERS_ADMIN = [{
    title: 'Id',
    sort: '',
    key: 'id',
    type: 'number',
    isSorteable: true
  }, {
    title: 'Envasadora',
    sort: '',
    key: 'description',
    type: 'string',
    isSorteable: true
  }, {
    title: 'Value stream',
    sort: '',
    key: 'value_stream',
    type: 'string',
    isSorteable: true,
    isCentered: true
  }, {
    title: 'Paralelo',
    sort: '',
    key: 'parallel',
    type: 'boolean',
    isSorteable: false,
    isCentered: true,
    isCheckField: true
  }, {
    title: 'Activo',
    sort: '',
    key: 'active',
    type: 'boolean',
    isSorteable: false,
    isCentered: true,
    isCheckField: true
  }, {
    title: 'Eliminar',
    sort: '',
    isSorteable: false,
    isColumnDelete: true,
    isCentered: true
  }];

  export const COLUMNS_HEADER_PACKAGING_ADMIN = [{
    title: 'Envasado',
    sort: '',
    key: 'id',
    type: 'number',
    isSorteable: true
  }, {
    title: 'Nombre envasado',
    sort: '',
    key: 'description',
    type: 'string',
    isSorteable: true
  },
  {
    title: 'Tiempo envasado',
    sort: '',
    key: 'time',
    type: 'number',
    isSorteable: true,
    isCentered: true
  }, {
    title: 'Activo',
    sort: '',
    key: 'active',
    type: 'boolean',
    isSorteable: false,
    isCentered: true,
    isCheckField: true
  },{
    title: 'Eliminar',
    sort: '',
    isSorteable: false,
    isColumnDelete: true,
    isCentered: true
  }];
  export const COLUMNS_HEADER_JOBS_ADMIN = [{
    title: 'Código',
    sort: '',
    key: 'code',
    type: 'string',
    isSorteable: true
  }, {
    title: 'Nombre',
    sort: '',
    key: 'name',
    type: 'string',
    isSorteable: true
  }, {
    title: 'Descripción',
    sort: '',
    key: 'description',
    type: 'string',
    isSorteable: true
  }, {
    title: 'Activo',
    sort: '',
    key: 'is_active',
    type: 'boolean',
    isSorteable: false,
    isCentered: true,
    isCheckField: true
  }];

  export const COLUMNS_HEADER_CLEANING_RULES_ADMIN = [
    {
      title: 'Id',
      sort: '',
      key: 'id',
      type: 'number',
      isSorteable: true
    }, {
    title: 'Producto anterior',
    sort: '',
    key: 'last_product',
    type: 'string',
    isSorteable: true
  }, {
    title: 'Producto siguiente',
    sort: '',
    key: 'next_product',
    type: 'string',
    isSorteable: true
  },{
    title: 'Tiempo mínimo',
    sort: '',
    key: 'min_time',
    type: 'number',
    isSorteable: false,
    isCentered: true
  }, {
    title: 'Tiempo máximo',
    sort: '',
    key: 'max_time',
    type: 'number',
    isSorteable: false,
    isCentered: true
  },{
    title: 'Tipo de limpieza',
    sort: '',
    key: 'name',
    type: 'string',
    isSorteable: true
  },{
    title: 'Eliminar',
    sort: '',
    isSorteable: false,
    isColumnDelete: true,
    isCentered: true
  }];

  export const COLUMNS_HEADER_QUALITY_ACTIONS_ADMIN = [{
    title: 'Código',
    sort: '',
    key: 'code',
    type: 'string',
    isSorteable: true
  }, {
    title: 'Código tarjeta ajuste',
    sort: '',
    key: 'action_code',
    type: 'string',
    isSorteable: true
  }, {
    title: 'Descripción',
    sort: '',
    key: 'description',
    type: 'string',
    isSorteable: true
  }, {
    title: 'Tipo',
    sort: '',
    key: 'type',
    type: 'string',
    isSorteable: true
  }, {
    title: 'Condición',
    sort: '',
    key: 'condition',
    type: 'string',
    isSorteable: true
  }, {
    title: 'Valor',
    sort: '',
    key: 'value',
    type: 'string',
    isSorteable: true
  }, {
    title: 'Creación de tarjeta',
    sort: '',
    key: 'create_card',
    type: 'string',
    isSorteable: true
  }, {
    title: 'Retraso',
    sort: '',
    key: 'delay',
    type: 'number',
    isSorteable: true,
    isCentered: true
  }, {
    title: 'Eliminar',
    sort: '',
    isSorteable: false,
    isColumnDelete: true,
    isCentered: true
  }];

  export const COLUMNS_HEADER_FINE_TUNNING = [{
    title: 'Grad',
    sort: '',
    key: 'grad',
    type: 'string',
    isSorteable: false,
    isCentered: true
  },
  {
    title: 'Nombre',
    sort: '',
    key: 'name',
    type: 'string',
    isSorteable: false,
    isCentered: true
  },
  {
    title: 'Blender',
    sort: '',
    key: 'blender',
    type: 'object',
    isSorteable: false,
    isCentered: true
  },
  {
    title: 'Hora inicio blender',
    sort: '',
    key: 'fecha_inicio_blender',
    type: 'date',
    isSorteable: false
  }, {
    title: 'Hora fin blender',
    sort: '',
    key: 'fecha_fin_blender',
    type: 'date',
    isSorteable: false
  },{
    title: 'Tiempo Fabricación',
    sort: '',
    key: 'production_time',
    type: 'number',
    isSorteable: false,
    isCentered: true
  },
  {
    title: 'Tiempo Calidad',
    sort: '',
    key: 'quality_time',
    type: 'number',
    isSorteable: false,
    isCentered: true
  },
  { title: 'Fert',
    sort: '',
    key: 'fert',
    type: 'string',
    isSorteable: false,
    isCentered: true
  },
  {
    title: 'Envasadora',
    sort: '',
    key: 'packaging_machine',
    type: 'object',
    isSorteable: false,
    isCentered: true
  },
  {
    title: 'Hora inicio envasadora',
    sort: '',
    key: 'fecha_inicio_envasadora',
    type: 'date',
    isSorteable: false
  }, {
    title: 'Hora fin envasadora',
    sort: '',
    key: 'fecha_fin_envasadora',
    type: 'date',
    isSorteable: false
  } , {
    title: 'Tiempo envasado',
    sort: '',
    key: 'packaging_time',
    type: 'number',
    isSorteable: false,
    isCentered: true
  },
];

  export const COLUMNS_HEADER_VIEW_APO = [{
    title: 'Grad',
    sort: '',
    key: 'product_grad',
    type: 'string',
    isSorteable: false,
    isCentered: true
  },
  {
    title: 'Nombre',
    sort: '',
    key: 'name',
    type: 'string',
    isSorteable: true
  },
  {
    title: 'Last day',
    sort: '',
    key: 'last_day',
    type: 'date',
    isSorteable: false
  },
   {
    title: 'Peso (kg)',
    sort: '',
    key: 'weight',
    type: 'number',
    isSorteable: false,
    isCentered: true
  }, {
    title: 'Blender',
    sort: '',
    key: 'blender',
    type: 'object',
    isSorteable: false,
  },
  {
    title: 'Fecha inicio',
    sort: '',
    key: 'fecha_inicio_blender',
    type: 'date',
    isSorteable: false
  },
  {
    title: 'Fecha fin',
    sort: '',
    key: 'fecha_fin_blender',
    type: 'date',
    isSorteable: false
  },
  {
    title: 'Fert',
    sort: '',
    key: 'fert',
    type: 'string',
    isSorteable: false,
    isViewApo: true,
    isCentered: true
  },{
    title: 'Envasadora',
    sort: '',
    key: 'packaging_machine',
    type: 'object',
    isSorteable: false
  },{
    title: 'Nº Env',
    sort: '',
    key: 'packaging_quantity',
    type: 'number',
    isSorteable: false,
    isCentered: true
  },
  {
    title: 'Fecha inicio Envasadora',
    sort: '',
    key: 'fecha_inicio_envasadora',
    type: 'date',
    isSorteable: false
  },
  {
    title: 'Fecha fin Envasadora',
    sort: '',
    key: 'fecha_fin_envasadora',
    type: 'date',
    isSorteable: false
  },
   {
    title: 'Tipo demanda',
    sort: '',
    key: 'demand_type',
    type: 'string',
    isSorteable: true,
    isCentered: true
  },
  {
    title: 'Cargado Kanbanize',
    sort: '',
    key: 'load_kanbanize',
    type: 'boolean',
    isSorteable: false,
    isCentered: true,
    isCheckField: true

  },
  {
    title: 'Fecha carga',
    sort: '',
    key: 'fecha_carga',
    type: 'date',
    isSorteable: false
  },
  {
    title: 'Eliminar',
    sort: '',
    isSorteable: false,
    isColumnDelete: true,
    isCentered: true,
    isViewApo: true
  }
];

export const COLUMNS_HEADER_VIEW_PROVISIONAL = [
{
  title: 'Plan',
  sort: '',
  key: 'to_plan',
  type: 'checkbox',
  isSorteable: false,
  isCentered: true
},
{
  title: 'Lote interno',
  sort: '',
  key: 'lote_interno',
  type: 'string',
  isSorteable: false,
  isEditable: true,
  editType: 'text'
},
{
  title: 'Grad',
  sort: '',
  key: 'product',
  type: 'string',
  isSorteable: false,
  isCentered: true
},
{
  title: 'Nombre',
  sort: '',
  key: 'name',
  type: 'string',
  isSorteable: false
},
{
  title: 'FERT',
  sort: '',
  key: 'material',
  type: 'string',
  isSorteable: false
},
{
  title: 'Last day',
  sort: '',
  key: 'last_day',
  type: 'date',
  isSorteable: false,
  isEditable: true,
  editType: 'date'
},
{
  title: 'Peso (kg)',
  sort: '',
  key: 'weight',
  type: 'number',
  isSorteable: false,
  isCentered: true,
  isEditable: true,
  editType: 'number'
},
{
  title: 'Blender',
  sort: '',
  key: 'blender',
  type: 'string',
  isSorteable: false,
  isCentered: true,
  isEditable: true,
  editType: 'select',
  optionsKey: 'blenderOptions'
},
{
  title: 'Envasadora',
  sort: '',
  key: 'packaging_machine',
  type: 'string',
  isSorteable: false,
  isCentered: true,
  isEditable: true,
  editType: 'select',
  optionsKey: 'packagingMachineOptions'
},
{
  title: 'Nº Env',
  sort: '',
  key: 'packaging_quantity',
  type: 'number',
  isSorteable: false,
  isCentered: true,
  isEditable: true,
  editType: 'number'
},
{
  title: 'Tiempo Fabricación',
  sort: '',
  key: 'production_time',
  type: 'number',
  isSorteable: false,
  isCentered: true,
  isEditable: true,
  editType: 'number'
},
{
  title: 'Tiempo Calidad',
  sort: '',
  key: 'quality_time',
  type: 'number',
  isSorteable: false,
  isCentered: true,
  isEditable: true,
  editType: 'number'
},
{
  title: 'Tiempo Envasado',
  sort: '',
  key: 'packaging_time',
  type: 'number',
  isSorteable: false,
  isCentered: true,
  isEditable: true,
  editType: 'number'
},
{
  title: 'Tiempo Total',
  sort: '',
  key: 'total_time',
  type: 'number',
  isSorteable: false,
  isCentered: true,
  isEditable: true,
  editType: 'number'
},
{
  title: 'Naturaleza producto',
  sort: '',
  key: 'product_nature',
  type: 'string',
  isSorteable: false,
  isEditable: true,
  editType: 'text'
},
{
  title: 'Pérdida (%)',
  sort: '',
  key: 'loss_percent',
  type: 'number',
  isSorteable: false,
  isCentered: true,
  isEditable: true,
  editType: 'number',
  editableForDemandType: 'MTS'
},
{
  title: 'Tipo demanda',
  sort: '',
  key: 'demand_type',
  type: 'string',
  isSorteable: false,
  isCentered: true,
  isEditable: true,
  editType: 'select',
  optionsKey: 'demandTypeOptions'
}
];

  export const COLUMNS_HEADER_PRODUCTS_ADMIN = [{
    title: 'Grad',
    sort: '',
    key: 'id',
    type: 'number',
    isSorteable: true
  }, {
    title: 'Producto',
    sort: '',
    key: 'description',
    type: 'string',
    isSorteable: true
  }, {
    title: 'Naturaleza del producto',
    sort: '',
    key: 'product_nature',
    type: 'string',
    isSorteable: true
  },
  {
    title: 'Activo',
    sort: '',
    key: 'active',
    type: 'boolean',
    isSorteable: true,
    isCentered: true,
    isCheckField: true
  },{
    title: 'Eliminar',
    sort: '',
    isSorteable: false,
    isColumnDelete: true,
    isCentered: true
  }];

  export const COLUMNS_HEADER_MMPP_PRODUCTS_ADMIN = [{
    title: 'Id',
    sort: '',
    key: 'id',
    type: 'number',
    isSorteable: true
  }, {
    title: 'Mixtion',
    sort: '',
    key: 'mixtion',
    type: 'string',
    isSorteable: true
  }, {
    title: 'Zona',
    sort: '',
    key: 'zona',
    type: 'string',
    isSorteable: true
  },{
    title: 'Super',
    sort: '',
    key: 'super',
    type: 'string',
    isSorteable: true
  },{
    title: 'InviernoH',
    sort: '',
    key: 'inviernoH',
    type: 'string',
    isSorteable: true
  },{
    title: 'InviernoNH',
    sort: '',
    key: 'inviernoNH',
    type: 'number',
    isSorteable: true
  },{
    title: 'VeranoH',
    sort: '',
    key: 'veranoH',
    type: 'string',
    isSorteable: true
  },{
    title: 'VeranoNH',
    sort: '',
    key: 'veranoNH',
    type: 'number',
    isSorteable: true
  },{
    title: 'Activo',
    sort: '',
    key: 'is_active',
    type: 'boolean',
    isSorteable: false,
    isCentered: true,
    isCheckField: true
  },{
    title: 'Eliminar',
    sort: '',
    isSorteable: false,
    isColumnDelete: true,
    isCentered: true
  }];

  export const COLUMNS_HEADER_CLEANINGS_ADMIN = [{
    title: 'Id',
    sort: '',
    key: 'id',
    type: 'number',
    isSorteable: true
  }, {
    title: 'Descripción',
    sort: '',
    key: 'name',
    type: 'string',
    isSorteable: true
  },
  {
    title: 'Duración',
    sort: '',
    key: 'duration',
    type: 'number',
    isSorteable: true
  },
  {
    title: 'Fecha inicio blender',
    sort: '',
    key: 'fecha_inicio_blender',
    type: 'date',
    isSorteable: true
  },
  {
    title: 'Fecha fin blender',
    sort: '',
    key: 'fecha_fin_blender',
    type: 'date',
    isSorteable: true
  },{
    title: 'Activa',
    sort: '',
    key: 'active',
    type: 'boolean',
    isSorteable: false,
    isCentered: true,
    isCheckField: true
  }, {
    title: 'Eliminar',
    sort: '',
    isSorteable: false,
    isColumnDelete: true,
    isCentered: true
  }];

  export const COLUMNS_HEADER_BITS_ADMIN = [{
    title: 'Bit',
    sort: '',
    key: 'bit',
    type: 'string',
    isSorteable: true
  }, {
    title: 'Planta',
    sort: '',
    key: 'planta',
    type: 'string',
    isSorteable: true
  }, {
    title: 'Reactor',
    sort: '',
    key: 'reactor_code',
    type: 'string',
    isSorteable: true
  }, {
    title: 'Producto',
    sort: '',
    key: 'product_code',
    type: 'string',
    isSorteable: true
  }, {
    title: 'Tag',
    sort: '',
    key: 'tag',
    type: 'string',
    isSorteable: true
  }, {
    title: 'Fecha ON',
    sort: '',
    key: 'date_on',
    type: 'date',
    isSorteable: true
  }, {
    title: 'Fecha OFF',
    sort: '',
    key: 'date_off',
    type: 'date',
    isSorteable: true
  }];

  export const COLUMNS_HEADER_JOB_EXECUTIONS_ADMIN = [{
    title: '#',
    sort: '',
    key: 'id',
    type: 'number',
    isSorteable: true
  }, {
    title: 'Mensaje',
    sort: '',
    key: 'message',
    type: 'string',
    isSorteable: false
  }, {
    title: 'Fecha de creación',
    sort: '',
    key: 'created_at',
    type: 'date',
    isSorteable: false
  }, {
    title: 'Fecha de finalización',
    sort: '',
    key: 'finished_at',
    type: 'date',
    isSorteable: false
  }, {
    title: 'Ejecución',
    sort: '',
    key: 'type',
    type: 'enum',
    isSorteable: false,
    isCentered: true
  }, {
    title: 'Estado',
    sort: '',
    key: 'status',
    type: 'enum',
    isSorteable: false,
    isCentered: true
  }];

  export const COLUMNS_HEADER_MATERIALS_ADMIN = [
  {
    title: 'Fert',
    sort: '',
    key: 'fert',
    type: 'string',
    isSorteable: true
  }, {
    title: 'Material',
    sort: '',
    key: 'description',
    type: 'string',
    isSorteable: true
  }, {
    title: 'Peso',
    sort: '',
    key: 'weight',
    type: 'number',
    isSorteable: true
  }, {
    title: 'Grad',
    sort: '',
    key: 'product_id',
    type: 'number',
    isSorteable: true,
    isCentered: true
  }, {
    title: 'Envase',
    sort: '',
    key: 'packaging_id',
    type: 'number',
    isSorteable: true,
    isCentered: true
  },
  {
    title: 'Value stream',
    sort: '',
    key: 'value_stream',
    type: 'string',
    isSorteable: true,
    isCentered: true
  },
  {
    title: 'Activo',
    sort: '',
    key: 'is_active',
    type: 'boolean',
    isSorteable: false,
    isCentered: true,
    isCheckField: true
  }, {
    title: 'Eliminar',
    sort: '',
    isSorteable: false,
    isColumnDelete: true,
    isCentered: true
  }];

  export const COLUMNS_HEADER_PRODUCT_MIXTION_ADMIN = [{
    title: 'Grad',
    sort: '',
    key: 'grad',
    type: 'number',
    isSorteable: true
  }, {
    title: 'Nombre',
    sort: '',
    key: 'name',
    type: 'string',
    isSorteable: true
  },
  {
    title: 'Mixtion',
    sort: '',
    key: 'mixtion',
    type: 'string',
    isSorteable: true
  },
  {
    title: '% Cantidad MP',
    sort: '',
    key: 'cantidadMP',
    type: 'string',
    isSorteable: true
  },
  {
    title: 'Eliminar',
    sort: '',
    isSorteable: false,
    isColumnDelete: true,
    isCentered: true
  }];
